import React from "react";
// import { Link } from "react-router-dom";

import Pix1 from "./img/unleash logo white (1).png";

// import Pix2 from "./img/counselor-and-happy-couple-after-effective-marital-6GBE9L5 1.png";

// import Pix3 from "./img/Rectangle-35.png";

// import Pix4 from "./img/Rectangle-36.png";
// import Pix5 from "./img/why-choose-v1-shape2 1.png";

function Home() {
  return (
    <div className="hBanner">
      <div className="section1">
        {/* <div className="background"> */}
        {/* <div className="imgCover"></div> */}
        <div className="txtCover">
        <img src={Pix1} alt="" className="Img-1" />
          <h1>Empowering Lives, Transforming Future</h1>
        </div>
        {/* </div> */}
      </div>
    </div>
  );
}
export default Home;
